import React, { useState, useEffect, RefObject } from "react"
import branding from "../../branding/branding"
import { RouteComponentProps, Link, useHistory } from "react-router-dom"
import styled from "styled-components"
import GuestUserBannerSharedState from "../guestUserBanner/GuestUserBannerSharedState"
import GuestUserBanner from "../guestUserBanner/GuestUserBanner"
import TopBar from "../../navigationArea/TopBar"
import Breadcrumb from "../../navigationArea/Breadcrumb"
import { calcBreadcrumbLocations } from "../../tracking/RouteTracker"
import { useLanguageState } from "../../globalStates/LanguageState"
import { mySchedulePageRoute } from "../../navigationArea/RoutePaths"
import { useLoggedInState } from "../../globalStates/LoggedInUser"
import LobbyPageContent from "./LobbyPageContent"
import MyPageContent from "./MyPageContent"
import PrivacyPolicyModal from "../../ui/PrivacyPolicyModal"
import GuestModal from "../../ui/GuestModal"
import SayHelloModal from "../../ui/SayHelloModal"
import RecommendModal from "../../ui/RecommendModal"
import { ShareTargetType } from "../../backendServices/Types"
import { CalendarEntry } from "../../backendServices/BackendServices"
import CalendarEntryModal, { CalendarEntryModalViewMode } from "../../ui/CalendarEntryModal"
import CrsTabs from "../../ui/CrsTabs"
import { ActionType } from "../entitiesActions/actionsUtils"
import { ContentScrollContainer } from "../../ui/ScrollContainer"
import TopBannerSharedState from "../advertisingBanner/TopBannerSharedState"
import useWindowDimensions from "../../ui/WindowDimensionsHook"
import { useRef } from "react"
import { DesktopVersionContainer } from "../../utils/Device"
import { SimpleOrganization } from "../ExhibitorsPageContent"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Slider from "react-slick"
import { useAppState } from "../../globalStates/AppState"
import { IconArrowRightCarousel, IconArrowLeftCarousel } from "../../ui/Icons"

export const TileWrapperSpeakers = styled.div<{ $count?: number }>`
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: repeat(${(props) => props.$count}, 280px);
    grid-gap: ${branding.receptionPage.speakersTileGridGap ?? "10px"};
    /* grid-gap: 20px; */
    padding-bottom: 1.25rem;
`

export const MobileTileWrapperSpeakers = styled.div<{ $count?: number }>`
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: repeat(${(props) => props.$count}, 95px);
    grid-gap: ${branding.receptionPage.speakersTileGridGap ?? "10px"};
    /* grid-gap: 20px; */
    padding-bottom: 1.25rem;
`

/*********************************************************************************************
 * FAIR INFO
 **********************************************************************************************/

const FairInfoContainerContent = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`

const HeaderTitleRoot = styled.div`
    display: flex;
    flex-flow: column;
    align-items: center;
    vertical-align: center;
    justify-content: center;
    flex: 1;
`

const HeaderTitleText = styled.div`
    color: ${branding.secondaryTextColor ?? "#fff"};
    font-size: ${branding.receptionPage.headerTitleInitialFontSize ?? "100px"};
    font-family: ${branding.receptionPage.headerTitleFontFamily};
    text-align: center;
    font-style: normal;
    text-transform: ${branding.receptionPage.headerTitleTextTransform};
    font-weight: ${branding.receptionPage.headerTitleFontWeight};
    letter-spacing: ${branding.receptionPage.headerTitleLetterSpacing};
    z-index: 2;
    margin-top: ${branding.receptionPage.lobbyHeaderTitleMarginTop ?? "40px"};
    @media only screen and (max-width: 2200px) {
        font-size: ${5 - (branding.receptionPage.headerTitleFontSizeIndex ?? 0) + "vw"};
        margin-top: ${branding.receptionPage.lobbyHeaderTitleMarginTopForSmallerScreen ?? "0px"};
    }
    @media only screen and (max-width: 1800px) {
        font-size: ${4.38 - (branding.receptionPage.headerTitleFontSizeIndex ?? 0) + "vw"};
        margin-top: ${branding.receptionPage.lobbyHeaderTitleMarginTopForSmallerScreen ?? "0px"};
    }

    @media only screen and (max-width: 1500px) {
        font-size: ${3.91 - (branding.receptionPage.headerTitleFontSizeIndex ?? 0) + "vw"};
        margin-top: ${branding.receptionPage.lobbyHeaderTitleMarginTopForSmallerScreen ?? "0px"};
    }

    @media only screen and (max-width: 1200px) {
        font-size: ${3.6 - (branding.receptionPage.headerTitleFontSizeIndex ?? 0) + "vw"};
        margin-top: ${branding.receptionPage.lobbyHeaderTitleMarginTopForSmallerScreen ?? "0px"};
    }
`

const HeaderFooterText = styled.div<{ title: string; description: string }>`
    font-size: ${(props) =>
        props.title.length > props.description?.length
            ? 2.5 - branding.receptionPage.headerFooterFontSizeIndex + "vw"
            : `${
                  branding.receptionPage.receptionPageHeaderFontSize ? branding.receptionPage.receptionPageHeaderFontSize : "22px"
              }`};
    font-family: ${branding.font1};
    font-style: normal;
    font-weight: ${branding.receptionPage.receptionPageHeaderFontWeight};
    z-index: 2;
    color: ${branding.secondaryTextColor ?? "#fff"};
`

const MyScheduleHeader = styled.div<{ title: string; description: string }>`
    font-size: ${(props) => (props.title.length > props.description?.length ? "2.5vw" : "22px")};
    font-family: ${branding.font1};
    font-style: normal;
    font-weight: 300;
    color: ${branding.secondaryTextColor ?? "#fff"};
    a {
        color: ${branding.secondaryTextColor ?? "#fff"};
        border-bottom: 1px solid ${branding.secondaryTextColor ?? "#fff"};
    }
    z-index: 2;
    margin-top: ${branding.receptionPage.myFairHeaderSubtitleMarginTop ?? "5px"};
`

interface FairInfoProps {
    eventKey: string
    onRouteChange: (route: string) => void
    fairInfoRootRef?: React.RefObject<HTMLDivElement>
}

// const FairInfo: React.FunctionComponent<FairInfoProps> = (props) => {
//   const languageState = useLanguageState()
//   const strings = languageState.getStrings()
//   const scheduleLink = <Link style={{ textDecoration: "none" }} to={mySchedulePageRoute}>{strings.receptionPage.receptionPageMyHeaderDescriptionSecondPart}</Link>
//   const title = props.eventKey === "LOBBY" ? strings.receptionPage.receptionPageLobbyHeaderTitle : strings.receptionPage.receptionPageMyHeaderTitle
//   const description = props.eventKey === "LOBBY" ? strings.receptionPage.receptionPageLobbyHeaderDescription : branding.receptionPage.receptionPageMyFairHeaderDesc

//   const locations = calcBreadcrumbLocations(strings)
//   let breadcrumb = [{ to: locations[0], name: strings.sideIconBar.lobbyMenuText }]
//   if (props.eventKey === strings.receptionPage.receptionPageMyHeaderTitle) {
//     breadcrumb.push(
//       { to: "/", name: strings.receptionPage.receptionPageMyHeaderTitle }
//     )
//   }

//   const lobbyHeaderPool: string[] = branding.receptionPage.lobbyHeaderPool

//   const lobbyHeader: string = lobbyHeaderPool[(Math.random() * lobbyHeaderPool.length) | 0]

//   const isLobbyHeader: boolean = props.eventKey === "LOBBY"

//   return (
//     <FairInfoRoot ref={props.fairInfoRootRef}>
//       <FairInfoContainer
//         containerBackground={isLobbyHeader ? ("url(" + lobbyHeader + ")") : "url(/branding/banner.jpg)"}
//         isLobbyHeader={isLobbyHeader}>
//         <FairInfoContainerContent>
//           {<HeaderTitleRoot>
//             <HeaderTitleText>{title}</HeaderTitleText>
//             {isLobbyHeader ?
//               <HeaderFooterText
//                 title={title}
//                 description={description}>
//                 {description}
//               </HeaderFooterText> :
//               <MyScheduleHeader title={title} description={description}>{strings.receptionPage.receptionPageMyHeaderDescriptionFirstPart} {scheduleLink} {strings.receptionPage.receptionPageMyHeaderDescriptionThirdPart}</MyScheduleHeader>
//             }
//           </HeaderTitleRoot>
//           }
//         </FairInfoContainerContent>
//       </FairInfoContainer>
//     </FairInfoRoot>
//   )
// }

const CarouselInfoContainer = styled.div<{ containerBackground: string; isLobbyHeader: boolean }>`
    position: relative;
    color: white;
    margin: 0 -15px;
    /* height: 550px; */
    padding-top: 12.5%;
    background: ${(props) =>
            props.isLobbyHeader
                ? branding.receptionPage.lobbyHeaderLinearGradient1
                : branding.receptionPage.lobbyHeaderLinearGradient2},
        ${(props) => props.containerBackground};
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    display: flex;
    flex-direction: column;

    .networkingCollapsed {
        border-bottom: 0;
        padding-left: 8px;
        padding-right: 10px;
        a {
            padding-left: 0;
            padding-right: 0;
        }
    }

    .active {
        border-bottom: 0;
        padding-left: 8px;
        padding-right: 10px;
        a {
            padding-left: 0;
            padding-right: 0;
        }
    }
`

const MainCarouselDiv = styled.div`
    .slick-next,
    .slick-prev {
        width: 25px;
        height: 25px;
    }
    .slick-prev {
        left: 20px !important;
        z-index: 1;
    }
    .slick-next {
        right: 20px !important;
        z-index: 1;
    }
    .slick-dots {
        bottom: 20px !important;
    }
    .slick-dots li.slick-active button:before {
        color: #fff !important;
    }
    .slick-prev:before,
    .slick-next:before {
        font-size: 25px;
        opacity: 1;
    }

    .slick-dots li button:before {
        color: #fff !important;
        font-size: 10px;
        cursor: pointer;
    }
`
const IconWrapper = styled.div`
    &::before {
        content: none;
    }
`

const CarouselView: React.FunctionComponent<FairInfoProps> = (props) => {
    const languageState = useLanguageState()
    const strings = languageState.getStrings()
    const scheduleLink = (
        <Link style={{ textDecoration: "none" }} to={mySchedulePageRoute}>
            {strings.receptionPage.receptionPageMyHeaderDescriptionSecondPart}
        </Link>
    )
    const title =
        props.eventKey === "LOBBY"
            ? strings.receptionPage.receptionPageLobbyHeaderTitle
            : strings.receptionPage.receptionPageMyHeaderTitle
    const description =
        props.eventKey === "LOBBY"
            ? strings.receptionPage.receptionPageLobbyHeaderDescription
            : branding.receptionPage.receptionPageMyFairHeaderDesc

    const locations = calcBreadcrumbLocations(strings)
    let breadcrumb = [{ to: locations[0], name: strings.sideIconBar.lobbyMenuText }]
    if (props.eventKey === strings.receptionPage.receptionPageMyHeaderTitle) {
        breadcrumb.push({ to: "/", name: strings.receptionPage.receptionPageMyHeaderTitle })
    }

    const lobbyHeaderPool: string[] = branding.receptionPage.lobbyHeaderPool
    const lobbyHeaderPoolNumber: number[] = branding.receptionPage.lobbyHeaderPoolNumber

    const myPageHeaderPool: string[] = branding.receptionPage.myFairPageHeaderPool
    const myPageHeaderPoolNumber: number[] = branding.receptionPage.myFairPageHeaderPoolNumber

    const isLobbyHeader: boolean = props.eventKey === "LOBBY"
    const renderSlides = () =>
        lobbyHeaderPoolNumber.map((num, index) => (
            <CarouselInfoContainer
                key={index}
                containerBackground={"url(" + lobbyHeaderPool[num] + ")"}
                isLobbyHeader={isLobbyHeader}
            >
                <FairInfoContainerContent>
                    {
                        <HeaderTitleRoot>
                            <HeaderTitleText>{title}</HeaderTitleText>
                            <HeaderFooterText title={title} description={description}>
                                {description}
                            </HeaderFooterText>
                        </HeaderTitleRoot>
                    }
                </FairInfoContainerContent>
            </CarouselInfoContainer>
        ))

    const renderMyFairPageSlides = () =>
        myPageHeaderPoolNumber.map((num, index) => (
            <CarouselInfoContainer key={index} containerBackground={"url(" + myPageHeaderPool[num] + ")"} isLobbyHeader={false}>
                <FairInfoContainerContent>
                    {
                        <HeaderTitleRoot>
                            <HeaderTitleText>{title}</HeaderTitleText>
                            <MyScheduleHeader title={title} description={description}>
                                {strings.receptionPage.receptionPageMyHeaderDescriptionFirstPart} {scheduleLink}{" "}
                                {strings.receptionPage.receptionPageMyHeaderDescriptionThirdPart}
                            </MyScheduleHeader>
                        </HeaderTitleRoot>
                    }
                </FairInfoContainerContent>
            </CarouselInfoContainer>
        ))

    return (
        <MainCarouselDiv className="App">
            <Slider
                dots={true}
                slidesToShow={1}
                slidesToScroll={1}
                autoplay={lobbyHeaderPoolNumber.length > 1 || myPageHeaderPoolNumber.length > 1 ? true : false}
                autoplaySpeed={
                    isLobbyHeader ? branding.receptionPage.autoPlayValueLobbyPool : branding.receptionPage.autoPlayValueMyFairPool
                }
                nextArrow={<IconWrapper>{IconArrowRightCarousel({ fill: "#fff" })}</IconWrapper>}
                prevArrow={<IconWrapper>{IconArrowLeftCarousel({ fill: "#fff" })}</IconWrapper>}
            >
                {isLobbyHeader ? renderSlides() : renderMyFairPageSlides()}
            </Slider>
        </MainCarouselDiv>
    )
}

/*********************************************************************************************
 * HEADER ROW
 **********************************************************************************************/

const HeaderRow = styled.div<{ showShadow?: boolean }>`
    position: ${(props) => (props.showShadow ? "sticky" : "relative")};
    top: 0;
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    height: 115px;
    color: ${branding.mainInfoColor};
    //box-shadow: ${(props) => (props.showShadow ? branding.primaryScrollDarkShadowTTB : "initial")};
    background-color: #fff;
    z-index: ${(props) => (props.showShadow ? 10001 : 0)};
    padding: ${(props) => (props.showShadow ? "0 15px 25px 15px" : 0)};
    box-sizing: ${(props) => (props.showShadow ? "content-box" : "border-box")};
    flex-direction: column;
    &:: before {
    content: "";
    position: absolute;
    z-index: -1;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    height: 140px;
    box-shadow: ${(props) => (props.showShadow ? branding.primaryScrollDarkShadowTTB : "initial")};
    }

`
interface HeaderRowProps {
    eventKey: string
    onEventKeySelect: React.Dispatch<React.SetStateAction<string>>
    showShadow?: boolean
    breadcrumb?: any
    ref?: any
}

const HeaderRowContent: React.FunctionComponent<HeaderRowProps> = (props) => {
    const languageState = useLanguageState()
    const strings = languageState.getStrings()
    const itemsOrder: any = branding.receptionPage.crsTabsItemOrder
    //eslint-disable-next-line
    const [breadcrumbRef, setBreadcrumbRef] = useState<RefObject<HTMLDivElement>>()
   
    enum viewType {
        LOBBY = "LOBBY",
        MY_FAIR = "MY_FAIR"
    }

    let items: any = []

    itemsOrder.forEach((item: any) => {
        let newItem
        switch (item) {
            case viewType.LOBBY:
                newItem = { label: strings.receptionPage.eventKeyLobby, value: viewType.LOBBY }
                break
            case viewType.MY_FAIR:
                newItem = { label: strings.receptionPage.eventKeyMyPage, value: viewType.MY_FAIR }
                break
        }
        items.push(newItem)
    })

    return (
        
        <HeaderRow showShadow={props.showShadow}>
            <Breadcrumb breadcrumb={props.breadcrumb} setRef={setBreadcrumbRef} />
            <CrsTabs
                tabItems={items}
                activeItem={items.length === 1 ? items[0].value : props.eventKey}
                onTabItemClicked={props.onEventKeySelect}
            />
        </HeaderRow>
        
        
    )
}

/*********************************************************************************************
 * RECEPTION PAGE CONTENT
 **********************************************************************************************/

const ReceptionPageRoot = styled.div<{ guestBannerHeight: number }>`
    height: 100%; //calc(100% - ${(props) => props.guestBannerHeight + 50 + "px"});
`

const MainContent = styled.div<{height?: number, carouselHeight: number, headerRowHeight: number}>`
    height: 100%;
    width: 100%;
    background-color: white;

    & .ScrollbarsCustom-TrackY {
        z-index: 10001;
    }

   & .ScrollbarsCustom-Track {
        top: ${props => props.carouselHeight + props.headerRowHeight + 160 + 'px'} !important; // fix this not to be hard coded
        height: ${props => "calc(100% - " + props.carouselHeight + props.headerRowHeight + 180  + 'px)'} !important;// fix this not to be hard coded
   }

`

const MainContentRoot = styled.div`
    padding-bottom: 44px;
`

const ToggledContent = styled.div<{ displayed: string }>`
    display: ${(props) => props.displayed};
    flex-flow: column;
`

interface ReceptionPageProps extends RouteComponentProps {
    receptionRoute: string
    trigger: number
    changeRoute: (route: string) => void
}

const ReceptionPageContentRefactored: React.FunctionComponent<ReceptionPageProps> = (props) => {
    let userState = useLoggedInState()
    const { guestUserBannerRef, setGuestUserBannerRef } = GuestUserBannerSharedState()
    const { topBarRef, setTopBarRef } = TopBannerSharedState()
    const [eventKey, setEventKey] = useState(props.receptionRoute ? props.receptionRoute : "LOBBY")
    const [action, setAction] = useState<ActionType | undefined>()
    const [showPrivacyPolicyModal, setShowPrivacyPolicyModal] = useState<boolean>(false)
    const [showRequestMeetingModal, setShowRequestMeetingModal] = useState(false)
    const [showRequestOrganizationModal, setShowRequestOrganizationModal] = useState(false)
    const [showGuestModal, setShowGuestModal] = useState<boolean>(false)
    const [targetId, setTargetId] = useState<string>("")
    const [target, setTarget] = useState<SimpleOrganization>()
    const [type, setType] = useState<ShareTargetType>()
    const [selecetedMeeting, setSelectedMeeting] = useState<CalendarEntry>()
    const [link, setLink] = useState<string>("")
    const [showRecommendOrganizationModal, setShowRecommendOrganizationModal] = useState(false)
    const [viewMode, setViewMode] = useState(CalendarEntryModalViewMode.CREATE)
    const [refreshKey, setRefreshKey] = useState(0)
    const fairInfoRootRef = useRef<HTMLDivElement>(null)
    const [showShadow, setShowShadow] = useState(false)
    const [hideOnScroll, setHideOnScroll] = useState(false)
    // eslint-disable-next-line
    const [breadcrumbRef, setBreadcrumbRef] = useState<RefObject<HTMLDivElement>>()
    const { isMobile } = useWindowDimensions()
    const carouselRef = useRef<HTMLDivElement>(null)
    const headerRowRef = useRef<HTMLDivElement>(null)
    const appState = useAppState()
    const lang = useLanguageState().getLanguage()

    const policyCallback = (accepted: boolean) => {
        switch (action) {
            case "MEETING":
                setShowRequestMeetingModal(true)
                break
            case "INTEREST":
                setShowRequestOrganizationModal(true)
                break
        }
        setAction(undefined)
        setShowPrivacyPolicyModal(false)
    }

    const reload = props.location.state
    const history = useHistory()

    const strings = useLanguageState().getStrings()

    const locations = calcBreadcrumbLocations(strings)
    let breadcrumb = [{ to: locations[0], name: strings.sideIconBar.lobbyMenuText }]
    if (eventKey === "MY_FAIR") {
        breadcrumb.push({ to: "/", name: strings.receptionPage.eventKeyMyPage })
    }

    function setMobileBreadcrumb() {
        if (eventKey === "LOBBY") {
            appState.setCurrentMobileBreadcrumb(strings.sideIconBar.lobbyMenuText)
        } else {
            appState.setCurrentMobileBreadcrumb(strings.receptionPage.eventKeyMyPage)
        }
    }

    useEffect(() => {
        console.log('carouselRef', carouselRef.current?.clientHeight)
        console.log('headerRowRef', headerRowRef.current?.clientHeight)
    }, [carouselRef.current?.clientWidth, isMobile])

    useEffect(() => {
        if (reload) {
            setEventKey("LOBBY")
            props.changeRoute("LOBBY")
            history.replace("", !reload)
        } else {
            props.changeRoute(eventKey)
        }

        setMobileBreadcrumb()

        //eslint-disable-next-line
    }, [eventKey])

    useEffect(() => {
        setMobileBreadcrumb()
        // eslint-disable-next-line
    }, [lang])

    useEffect(() => {
        setEventKey(props.receptionRoute ? props.receptionRoute : "LOBBY")
    }, [props.trigger, props.receptionRoute])

    const handleScroll = (scrollValues: any) => {
        
        if(scrollValues.contentScrollHeight > scrollValues.clientHeight) {
            setHideOnScroll(scrollValues.scrollTop > 0)
            setShowShadow(scrollValues.scrollTop > 0)
        }else {
            setHideOnScroll(true)
        }

        if (scrollValues && fairInfoRootRef.current && breadcrumbRef?.current) {
            if (scrollValues.scrollTop > fairInfoRootRef.current?.clientHeight + breadcrumbRef?.current.clientHeight) {
                if (!showShadow) setShowShadow(true)
            } else {
                if (showShadow) setShowShadow(false)
            }
        }
    }

    const heightToAdjust =
        (topBarRef && topBarRef.current ? topBarRef.current.clientHeight : 0) +
        (guestUserBannerRef && guestUserBannerRef.current ? guestUserBannerRef.current.clientHeight : 0)
    return (
        <ReceptionPageRoot
            guestBannerHeight={guestUserBannerRef && guestUserBannerRef.current ? guestUserBannerRef.current.clientHeight : 0}
        >
            <DesktopVersionContainer>
                <GuestUserBanner setRef={setGuestUserBannerRef} />
                <TopBar setRef={setTopBarRef} />
            </DesktopVersionContainer>

            <MainContent className="scroll" height={heightToAdjust} carouselHeight={carouselRef.current?.clientHeight || 0} headerRowHeight={headerRowRef.current?.clientHeight || 0}>
                <ContentScrollContainer handleScroll={handleScroll} adjustForHeaderWith={heightToAdjust + "px"}>
                    <MainContentRoot style={{ paddingBottom: isMobile ? "130px" : "44px" }}>
                        {showPrivacyPolicyModal && target && (
                            <PrivacyPolicyModal
                                callback={policyCallback}
                                organizationId={target!.id}
                                consentText={target!.consentText}
                                consentTitle={target!.consentTitle}
                            />
                        )}
                        {showGuestModal && <GuestModal close={() => setShowGuestModal(false)} />}
                        {showRequestOrganizationModal && (
                            <SayHelloModal
                                organizationModal={true}
                                targetId={target?.id!}
                                handleClose={() => setShowRequestOrganizationModal(false)}
                            ></SayHelloModal>
                        )}
                        {showRecommendOrganizationModal && (
                            <RecommendModal
                                targetId={type === ShareTargetType.ORGANIZATION ? target?.id! : targetId}
                                type={type!}
                                link={`https://${window.location.hostname}` + link}
                                sotUser={[]}
                                close={() => setShowRecommendOrganizationModal(false)}
                            ></RecommendModal>
                        )}
                        {showRequestMeetingModal && (
                            <CalendarEntryModal
                                viewMode={viewMode}
                                calendarEntry={viewMode !== CalendarEntryModalViewMode.CREATE ? selecetedMeeting : undefined}
                                organizationId={target?.id}
                                sotUser={[]}
                                close={() => setShowRequestMeetingModal(false)}
                                onUpdated={() => setRefreshKey(1)}
                            />
                        )}

                        {isMobile ? (
                            <div />
                        ) : (
                            <>
                                {/* <FairInfo fairInfoRootRef={fairInfoRootRef} eventKey={eventKey} onRouteChange={props.changeRoute} /> */}
                                {!hideOnScroll && <div ref={carouselRef}><CarouselView
                                    
                                    fairInfoRootRef={fairInfoRootRef}
                                    eventKey={eventKey}
                                    onRouteChange={props.changeRoute}
                                ></CarouselView></div> }

                                

                                <HeaderRowContent ref={headerRowRef} breadcrumb={breadcrumb} showShadow={showShadow} eventKey={eventKey} onEventKeySelect={setEventKey} />
                            </>
                        )}
                        <ToggledContent displayed={"flex"}>
                            {eventKey === "LOBBY" ? (
                                <LobbyPageContent
                                    eventKey={eventKey}
                                    refreshKey={refreshKey}
                                    onSetAction={setAction}
                                    onSetShowPrivacyPolicyModal={setShowPrivacyPolicyModal}
                                    onSetShowGuestModal={setShowGuestModal}
                                    onSetShowOrganizationModal={setShowRecommendOrganizationModal}
                                    onSetTarget={setTarget}
                                    onSetTargetId={setTargetId}
                                    onSetLink={setLink}
                                    onSetType={setType}
                                    profileId={userState.user()?.profileId!}
                                    isMobile={isMobile}
                                />
                            ) : (
                                <MyPageContent
                                    onViewModeSet={setViewMode}
                                    eventKey={eventKey}
                                    guestBannerHeight={guestUserBannerRef?.current?.clientHeight || 0}
                                    onSetAction={setAction}
                                    onSetShowGuestModal={setShowGuestModal}
                                    onSetShowPrivacyPolicyModal={setShowPrivacyPolicyModal}
                                    onSetShowOrganizationModal={setShowRecommendOrganizationModal}
                                    onSetTarget={setTarget}
                                    onSetTargetId={setTargetId}
                                    onSetLink={setLink}
                                    onSetType={setType}
                                    onSelectedMeetingSet={setSelectedMeeting}
                                    isMobile={isMobile}
                                />
                            )}
                        </ToggledContent>
                    </MainContentRoot>
                </ContentScrollContainer>
            </MainContent>
        </ReceptionPageRoot>
    )
}

export default ReceptionPageContentRefactored
